import styled from 'styled-components';
import { STICKY_COLUMNS_WIDTH } from '../../TableContent.styles';
import { Box } from '../../../../../../../../../../../../CommonComponents/OPL/Box/Box';

export const TableRow = styled.tr<{ isExpandable?: boolean }>(({ isExpandable }) => ({
  ...(isExpandable
    ? {
        userSelect: 'none',
        tabIndex: 0,
        role: 'button',
        outline: 'none',
        cursor: 'pointer',
      }
    : {}),
}));

interface FixedTableDataProps {
  columnPosition: number;
}

export const StickyTableData = styled.td<FixedTableDataProps>(({ theme, columnPosition }) => ({
  position: 'sticky',
  left: `calc((${STICKY_COLUMNS_WIDTH}) * ${columnPosition})`,
  zIndex: 2,
  background: theme.colors.bg,

  '&:after': {
    content: "''",
    height: '100%',
    position: 'absolute',
    top: 0,
    width: '7px',
    boxShadow: '7px 0px 15px -15px inset rgba(55, 65, 81, 0.4)',
    right: '-7px',
  },
}));

interface IndentedTextProps {
  indentation: number;
  isExpandable?: boolean;
}

export const IndentedTextContent = styled(Box)<IndentedTextProps>(
  ({ theme, indentation, isExpandable }) => {
    return {
      marginLeft: `calc(${theme.space[8]}px * ${indentation} ${
        isExpandable ? '' : `+ ${theme.space[16]}px + 1px`
      })`,
      display: 'flex',
      alignItems: 'center',
    };
  },
);
